import React, { useEffect, useState } from "react";
import axios from "axios";
import OfferFlipCountdownBanner from "./OfferCountdownBanner";
import { discount } from './apipath';

export default function GlobalCampaignBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${discount}campaign-active`)
      .then(res => setData(res.data))
      .catch(() => setData({ enabled: false }));
  }, []);

  if (!data?.enabled) return null;

  return (
    <OfferFlipCountdownBanner
      endAt={data.end_at}
      discounts={data.discounts || []}
      title={data.title}
      subtitle={data.subtitle}
      ctaText="立即選購"
      ctaHref="/quickbuy"
      allowClose={true}
      showDemoControls={false}
    />
  );
}
